<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Info Ujian",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination },
  data() {
    let sortOrders = [];
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "20%",
        label: "Jadwal Pelaksanaan",
        name: "jadwal_pelaksanaan",
      },
      {
        width: "90%",
        label: "Info Ujian",
        name: "info_ujian",
      },
      {
        width: "10%",
        label: "Status Info Ujian",
        name: "-",
      },
      {
        width: "230px",
        label: "Aksi",
        name: "-",
      },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    let columnsDemo = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "90%",
        label: "Info Ujian",
        name: "info_ujian",
      },
      {
        width: "10%",
        label: "Status Info Ujian",
        name: "-",
      },
      {
        width: "230px",
        label: "Aksi",
        name: "-",
      },
    ];

    columnsDemo.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    const menu = "Info Ujian";
    return {
      title: menu,
      loadingTable: true,
      tableData: [],
      columns: columns,
      sortKey: "pelaksanaan",
      sortOrders: sortOrders,
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "id",
        dir: "desc",
        status: "1",
        isActive: "all",
        info_ujian: "",
        type: "peserta",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      currentPage: 0,
      pelaksanaan: [],
      option_pelaksanaan: [],

      loadingTableDemo: true,
      tableDataDemo: [],
      columnsDemo: columnsDemo,
      sortKeyDemo: "pelaksanaan",
      sortOrdersDemo: sortOrders,
      tableFilterDemo: {
        page: 1,
        per_page: 10,
        search: "",
        column: "id",
        dir: "desc",
        status: "1",
        isActive: "all",
        info_ujian: "",
        type: 'dummy',
      },
      paginationDemo: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      currentPageDemo: 0,
    };
  },
  methods: {
    async getTableData(resetPage = true) {
      this.loadingTable = true;
      if (resetPage) {
        this.tableFilter.page = 1;
      }

      this.tableFilter.idjadwal_pelaksanaan = this.pelaksanaan
        ? this.pelaksanaan?.idjadwal_pelaksanaan
        : "";

      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "info-ujian",
        params: this.tableFilter,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableData = data.data.data;
        this.currentPage = data.data.current_page;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      this.getTableData(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getTableData();
    },
    addData() {
      this.$router.push({ name: "info-ujian-add" });
    },
    eidtData(row) {
      this.$router.push({ name: "info-ujian-edit", params: { id: row.id } });
    },
    setActive(id) {
      Swal.fire({
        icon: "question",
        title: "Apakah kamu yakin mengaktifkan data info ujian ini ?",
        text: "Data lain akan diset tidak aktif",
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `info-ujian/${id}/set-active`,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
            data: {
              is_active: 1,
            },
          })
            .then((response) => {
              console.log("response:", response.data);
              return true;
            })
            .catch((err) => {
              console.log("error", err);
              return false;
            });

          if (data) {
            Swal.fire({
              icon: "success",
              title: "Status berhasil diperbarui",
            });
          }
          this.getTableData();
        }
      });
    },
    updateStatus(row, status) {
      row.active_flag = status;
      const label = status === 1 ? "mengaktifkan" : "menonaktifkan";

      Swal.fire({
        icon: "question",
        title: `Apakah Anda yakin ingin ${label} data ini?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION + "info-ujian/" + row.id,
            data: row,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err update status:", err);
              row.active_flag = row.active_flag === 1 ? 0 : 1; // rollback status
              Swal.fire({
                icon: "error",
                title: "Terjadi Kesalahan",
                text: err.response.data.data,
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Status berhasil diperbarui",
            });
            this.getTableData();
          }
        } else {
          row.active_flag = row.active_flag === 1 ? 0 : 1; // rollback status
        }
      });
    },
    destroy(id) {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menghapus data ini ?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "info-ujian/" + id,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Data Berhasil dihapus",
            });
            this.getTableData();
          }
        }
      });
    },
    stripHtmlTags(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    searchPelaksanaan(loading, search) {
      loading(true);
      this.getFilterPelaksanaan(search, loading);
    },
    async getFilterPelaksanaan(search, loading) {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/jadwal-pelaksanaan/all",
        params: {
          search: search,
          limit: 50,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data.data)
        .catch((err) => {
          console.log("err get jadwal pelaksanaan", err);
          return false;
        });

      if (data) this.option_pelaksanaan = data;

      if (loading) loading(false);
    },

    async getTableDataDemo(resetPage = true) {
      if (resetPage) {
        this.tableFilterDemo.page = 1;
      }
      this.loadingTableDemo = true;
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "info-ujian",
        params: this.tableFilterDemo,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableDataDemo = data.data.data;
        this.currentPageDemo = data.data.current_page;
        this.paginationDemo.total = data.data.total;
        this.paginationDemo.from = data.data.from;
        this.paginationDemo.to = data.data.to;
        this.paginationDemo.links = data.data.links;
        this.paginationDemo.lastPageUrl = data.last_page_url;
        this.paginationDemo.nextPageUrl = data.next_page_url;
        this.paginationDemo.prevPageUrl = data.prev_page_url;
        this.paginationDemo.per_page = this.tableFilterDemo.per_page;
        this.paginationDemo.page = this.tableFilterDemo.page;
      }
      this.loadingTableDemo = false;
    },
    toPageDemo(url) {
      let link = new URLSearchParams(url);
      this.tableFilterDemo.page = link.get("page");
      this.getTableDataDemo(false);
    },
    sortByDemo(key) {
      this.sortKeyDemo = key;
      this.sortOrdersDemo[key] = this.sortOrdersDemo[key] * -1;
      this.tableFilterDemo.column = key;
      this.tableFilterDemo.dir = this.sortOrdersDemo[key] === 1 ? "asc" : "desc";
      this.getTableDataDemo();
    },
    addDataDemo() {
      this.$router.push({ name: "info-ujian-demo-add" });
    },
    eidtDataDemo(row) {
      this.$router.push({ name: "info-ujian-demo-edit", params: { id: row.id } });
    },
    setActiveDemo(id) {
      Swal.fire({
        icon: "question",
        title: "Apakah kamu yakin mengaktifkan data info ujian ini ?",
        text: "Data lain akan diset tidak aktif",
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `info-ujian/${id}/set-active`,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
            data: {
              is_active: 1,
            },
          })
            .then((response) => {
              console.log("response:", response.data);
              return true;
            })
            .catch((err) => {
              console.log("error", err);
              return false;
            });

          if (data) {
            Swal.fire({
              icon: "success",
              title: "Status berhasil diperbarui",
            });
          }
          this.getTableDataDemo();
        }
      });
    },
    updateStatusDemo(row, status) {
      row.active_flag = status;
      const label = status === 1 ? "mengaktifkan" : "menonaktifkan";

      Swal.fire({
        icon: "question",
        title: `Apakah Anda yakin ingin ${label} data ini?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION + "info-ujian/" + row.id,
            data: row,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err update status:", err);
              row.active_flag = row.active_flag === 1 ? 0 : 1; // rollback status
              Swal.fire({
                icon: "error",
                title: "Terjadi Kesalahan",
                text: err.response.data.data,
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Status berhasil diperbarui",
            });
            this.getTableDataDemo();
          }
        } else {
          row.active_flag = row.active_flag === 1 ? 0 : 1; // rollback status
        }
      });
    },
    destroyDemo(id) {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menghapus data ini ?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "info-ujian/" +
              id,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Data Berhasil dihapus",
            });
            this.getTableDataDemo();
          }
        }
      });
    },
  },
  async mounted() {
    this.getTableData();
    this.filterData = _.debounce(this.getTableData.bind(this), 500);
    await this.getFilterPelaksanaan("", false);

    this.getTableDataDemo();
    this.filterDataDemo = _.debounce(this.getTableDataDemo.bind(this), 500);
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Informasi Ujian Peserta</span>
                </template>
                <div class="d-flex flex-wrap justify-content-between">
                  <div class="card-title">Informasi Ujian Peserta</div>
                  <div class="d-flex gap-2">
                    <button class="btn btn-success btn-sm" @click="addData()">
                      <i class="fa fa-plus me-1"></i> Tambah
                    </button>
                  </div>
                </div>
                <hr />
                <div class="row mt-2">
                  <div class="form-group col-md-4">
                    <label for="filterInfoUjian">Info Ujian</label>
                    <input type="text" class="form-control" id="filterInfoUjian" placeholder="Filter Info Ujian" v-model="tableFilter.info_ujian" @input="filterData" />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="filterStatus">Status Info Ujian</label>
                    <select id="filterStatus" class="form-control" v-model="tableFilter.isActive" @change="getTableData()">
                      <option value="all">Semua</option>
                      <option value="1">Aktif</option>
                      <option value="0">Tidak Aktif</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="filterStatus">Pelaksanaan</label>
                    <v-select :options="option_pelaksanaan" v-model="pelaksanaan" label="pelaksanaan" placeholder="Pilih Pelaksanaan" @search="searchPelaksanaan" v-on:update:modelValue="getTableData()"></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="filterStatus">Status</label>
                    <select id="filterStatus" class="form-control" v-model="tableFilter.status" @change="getTableData()">
                      <option value="1">Aktif</option>
                      <option value="0">Tidak Aktif</option>
                    </select>
                  </div>
                </div>
                <hr />
                <Datatable :columns="columns" classTable="custom-table table mb-0 table-bordered table-condensed table-hover">
                  <tbody>
                    <tr v-if="loadingTable">
                      <td colspan="99" class="text-center">
                        <i class="fas fa-spinner fa-spin"></i> Loading
                      </td>
                    </tr>
                    <tr v-else-if="tableData.length < 1">
                      <td colspan="99" class="text-center">Data Empty</td>
                    </tr>
                    <tr v-else v-for="(row, key) in tableData" :key="key">
                      <td>
                        <span v-if="key + 1 == 10"> {{ currentPage }}0. </span>
                        <span v-else>
                          {{
                        currentPage - 1 != 0
                          ? currentPage - 1 + `${key + 1}`
                          : `${key + 1}`
                      }}.
                        </span>
                      </td>
                      <td>
                        <div class="long-text">
                          {{ row.jadwal_pelaksanaan?.pelaksanaan }}
                        </div>
                      </td>
                      <td>
                        <div class="long-text">
                          {{ stripHtmlTags(row.info_ujian) }}
                        </div>
                        <!-- <div v-html="row.info_ujian" class="long-text"></div> -->
                        <!-- {{ row.info_ujian }} -->
                      </td>
                      <td class="text-center">
                        <span v-if="row.is_active == 1" class="badge badge-pill badge-soft-success">
                      Aktif
                    </span>
                        <span v-else class="badge badge-pill badge-soft-danger">
                      Tidak Aktif
                    </span>
                      </td>
                      <td class="text-center">
                        <div class="btn-group btn-group-sm">
                          <button v-if="row.active_flag == 1 && row.is_active != 1" class="btn btn-info btn-sm" @click="setActive(row.id)">
                            <i class="fa fa-check"></i> Set Aktif
                          </button>
                          <button v-if="row.active_flag == 1" class="btn btn-warning btn-sm" @click="eidtData(row)">
                            <i class="fa fa-edit"></i> Edit
                          </button>
                          <button v-if="row.active_flag == 1" class="btn btn-danger btn-sm" @click="updateStatus(row, '0')">
                            <i class="fa fa-trash"></i> Disable
                          </button>
                          <button v-if="row.active_flag != 1" class="btn btn-success btn-sm" @click="updateStatus(row, '1')">
                            <i class="fa fa-trash-restore"></i> Enable
                          </button>
                          <button v-if="row.active_flag != 1" class="btn btn-danger btn-sm" @click="destroy(row.id)">
                            <i class="fa fa-trash"></i> Hapus
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Datatable>
                <Pagination :pagination="pagination" @to-page="toPage" />
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Informasi Ujian Demo</span>
                </template>
                <div class="d-flex flex-wrap justify-content-between">
                  <div class="card-title">Info Ujian</div>
                  <div class="d-flex gap-2">
                    <button class="btn btn-success btn-sm" @click="addDataDemo()">
                      <i class="fa fa-plus me-1"></i> Tambah
                    </button>
                  </div>
                </div>
                <hr />
                <div class="row mt-2">
                  <div class="form-group col-md-4">
                    <label for="filterInfoUjian">Info Ujian</label>
                    <input type="text" class="form-control" id="filterInfoUjian" placeholder="Filter Info Ujian" v-model="tableFilterDemo.info_ujian" @input="filterDataDemo" />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="filterStatus">Status Info Ujian</label>
                    <select id="filterStatus" class="form-control" v-model="tableFilterDemo.isActive" @change="getTableDataDemo()">
                      <option value="all">Semua</option>
                      <option value="1">Aktif</option>
                      <option value="0">Tidak Aktif</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="filterStatus">Status</label>
                    <select id="filterStatus" class="form-control" v-model="tableFilterDemo.status" @change="getTableDataDemo()">
                      <option value="1">Aktif</option>
                      <option value="0">Tidak Aktif</option>
                    </select>
                  </div>
                </div>
                <hr />
                <Datatable :columns="columnsDemo" classTable="custom-table table mb-0 table-bordered table-condensed table-hover">
                  <tbody>
                    <tr v-if="loadingTableDemo">
                      <td colspan="99" class="text-center">
                        <i class="fas fa-spinner fa-spin"></i> Loading
                      </td>
                    </tr>
                    <tr v-else-if="tableDataDemo.length < 1">
                      <td colspan="99" class="text-center">Data Empty</td>
                    </tr>
                    <tr v-else v-for="(row, key) in tableDataDemo" :key="key">
                      <td>
                        <span v-if="key + 1 == 10"> {{ currentPageDemo }}0. </span>
                        <span v-else>
                          {{
                        currentPageDemo - 1 != 0
                          ? currentPageDemo - 1 + `${key + 1}`
                          : `${key + 1}`
                      }}.
                        </span>
                      </td>
                      <td>
                        <div class="long-text">
                          {{ stripHtmlTags(row.info_ujian) }}
                        </div>
                        <!-- <div v-html="row.info_ujian" class="long-text"></div> -->
                        <!-- {{ row.info_ujian }} -->
                      </td>
                      <td class="text-center">
                        <span v-if="row.is_active == 1" class="badge badge-pill badge-soft-success">
                      Aktif
                    </span>
                        <span v-else class="badge badge-pill badge-soft-danger">
                      Tidak Aktif
                    </span>
                      </td>
                      <td class="text-center">
                        <div class="btn-group btn-group-sm">
                          <button v-if="row.active_flag == 1 && row.is_active != 1" class="btn btn-info btn-sm" @click="setActiveDemo(row.id)">
                            <i class="fa fa-check"></i> Set Aktif
                          </button>
                          <button v-if="row.active_flag == 1" class="btn btn-warning btn-sm" @click="eidtDataDemo(row)">
                            <i class="fa fa-edit"></i> Edit
                          </button>
                          <button v-if="row.active_flag == 1" class="btn btn-danger btn-sm" @click="updateStatusDemo(row, '0')">
                            <i class="fa fa-trash"></i> Disable
                          </button>
                          <button v-if="row.active_flag != 1" class="btn btn-success btn-sm" @click="updateStatusDemo(row, '1')">
                            <i class="fa fa-trash-restore"></i> Enable
                          </button>
                          <button v-if="row.active_flag != 1" class="btn btn-danger btn-sm" @click="destroyDemo(row.id)">
                            <i class="fa fa-trash"></i> Hapus
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Datatable>
                <Pagination :pagination="paginationDemo" @to-page="toPageDemo" />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.custom-table {
  table-layout: fixed;
  width: 100%;
}
</style>
<style scoped>
table {
  table-layout: fixed;
  width: 100%;
}

td .long-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  /* respects the td width */
  max-height: 200px;
}

.limited-html {
  max-height: 40px;
  /* atau sesuai kebutuhan */
  overflow: hidden;
  position: relative;
}
</style>